import React from 'react';

import { withServerData } from '@xingternal/hops';

import CenterImage from './../CenterImage/CenterImage';

import GdprGerSvg from './GdprGerSvg';
import GdprEngSvg from './GdprEngSvg';

const svgStyle = { maxWidth: '120px' };

const GdprImage = ({ serverData: { language } }) => {
  return language === 'de' ? (
    <CenterImage image={<GdprGerSvg styles={svgStyle} />} />
  ) : (
    <CenterImage image={<GdprEngSvg styles={svgStyle} />} />
  );
};

export default withServerData(GdprImage);
